var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, P, PCSS, CustomElement, Watch, PropertyConverters } from './_default-imports';
import { Matrix2D } from '@pacem/pacem-foundation';
import { SwipeEvent, SwipeEventArgsClass, SwipeEventType } from '../../ui/swipe';
import { CustomElementUtils } from '../../utils-customelement';
import { CustomEventUtils } from '../../utils-customevent';
import { PacemBehavior } from '../behavior';
//namespace Pacem.Components {
const GET_VAL = CustomElementUtils.getAttachedPropertyValue;
const SET_VAL = CustomElementUtils.setAttachedPropertyValue;
const DEL_VAL = CustomElementUtils.deleteAttachedPropertyValue;
const PREPARING_LABEL = 'pacem:swipe:preparing';
const DELEGATE_LABEL = 'pacem:swipe:delegate';
const DEFAULT_OPTIONS = { fling: 400, inertia: 8, start: 32, autoresetSpans: false, bouncy: true };
class SwipeElementDelegate {
    constructor(_element, _swiper, _init, _logFn) {
        this._element = _element;
        this._swiper = _swiper;
        this._init = _init;
        this._logFn = _logFn;
        this._moveHandler = (evt) => {
            const samples = this.#samples;
            const state = this._buildStateFromUiEvent(evt);
            samples.push(this.#state = state);
            while (samples.length > 0
                && state.timestamp - samples[0].timestamp > 100) {
                samples.shift();
            }
            const args = this._buildSwipeArgsFromState(state); // SwipeEventArgsClass.fromArgs({ position: state.position, element: this._element, t0: this._init, timestamp: state.timestamp });
            const swipeEvt = new SwipeEvent(SwipeEventType.Pan, args, { cancelable: true, bubbles: false });
            const swiper = this._swiper;
            swiper.dispatchEvent(swipeEvt);
            if (!swipeEvt.defaultPrevented) {
                let { delta } = this._delta(this._init, state);
                if (!swiper.options.bouncy) {
                    // clamp delta just in case
                    const snaps = swiper.snaps.slice().sort();
                    const snapFirst = snaps[0], snapLast = snaps[snaps.length - 1];
                    const dir = this._swiper.direction;
                    const { x, y } = delta;
                    const deltaX = x.clamp(snapFirst, snapLast), deltaY = y.clamp(snapFirst, snapLast);
                    delta = dir === 'vertical'
                        ? { x: 0, y: deltaY }
                        : { x: deltaX, y: 0 };
                }
                this._animateOffsetBy(delta, 0);
            }
        };
        this._endHandler = (evt) => {
            // detach move listener
            window.removeEventListener('pointermove', this._moveHandler);
            // estimate goal
            if (Utils.isNull(this.#state)) {
                console.log('How come?!');
            }
            else {
                const args = this._buildSwipeArgsFromState();
                const swipeEvt = new SwipeEvent(SwipeEventType.Swipe, args, { cancelable: true, bubbles: false });
                const swiper = this._swiper;
                swiper.dispatchEvent(swipeEvt);
                if (!swipeEvt.defaultPrevented) {
                    const swipe1Evt = new SwipeEvent(("swipe" + args.direction), args, { cancelable: true, bubbles: false });
                    swiper.dispatchEvent(swipe1Evt);
                    if (!swipe1Evt.defaultPrevented) {
                        // if the predicted distance is greater than the original position + half the distance to the nearest snap,
                        const snaps = swiper.snaps ?? [0.0];
                        snaps.sort();
                        const target = swiper.options.bouncy ? args.predictedDelta : args.predictedDelta.clamp(snaps[0], snaps[snaps.length - 1]);
                        // then animate toward that target,
                        // otherwise bounce back
                        const snap = snaps.reduce((acc, v) => {
                            const distance = Math.abs(v - target);
                            const current = Math.abs(acc - target);
                            return distance < current ? v : acc;
                        }, 0);
                        const vertical = swiper.direction === 'vertical';
                        const duration = args.predictedDuration;
                        const delta0 = vertical ? { x: 0, y: target } : { x: target, y: 0 };
                        // centralized swipeanimationend dispatcher
                        const swipeAnimationEnd = () => {
                            const swipe2Evt = new SwipeEvent(SwipeEventType.SwipeAnimationEnd, args, { cancelable: false, bubbles: false });
                            if (swiper.dispatchEvent(swipe2Evt)) {
                                return swipe2Evt;
                            }
                            return null;
                        };
                        if (snap.isCloseTo(0)) {
                            this._animateOffsetBy(delta0, duration).then(() => {
                                this._animateOffsetBy({ x: 0, y: 0 }, .3, 'cubic-bezier(.37,-0.01,.34,1.43)').then(() => swipeAnimationEnd());
                            });
                        }
                        else {
                            // animation to reach the predicted offset (if does not exceed the target snap, then void)
                            const doesNotExceed = (snap - target) * (snap - args.delta) >= 0;
                            const delta1 = vertical ? { x: 0, y: snap } : { x: snap, y: 0 };
                            // animation that reaches the correct snap
                            const animation = () => this._animateOffsetBy(delta1, doesNotExceed ? duration : .2, 'cubic-bezier(0,0,0,1)');
                            const promise = () => doesNotExceed ? Promise.resolve() : this._animateOffsetBy(delta0, duration);
                            promise().then(() => animation().then(() => {
                                // generic 
                                swipeAnimationEnd();
                                // specific
                                const swipe3Evt = new SwipeEvent(("swipe" + args.direction + "animationend"), args, { cancelable: false, bubbles: false });
                                swiper.dispatchEvent(swipe3Evt);
                            }));
                        }
                        if (this.#options.autoresetSpans) {
                            this._swiper.snaps = snaps.map(s => s - snap);
                        }
                    }
                }
            }
            this.dispose();
        };
        this.#samples = [];
        const el = _element;
        this.#options = Utils.extend({}, DEFAULT_OPTIONS, _swiper.options ?? {});
        this.#originalTransform = Utils.deserializeTransform(getComputedStyle(el));
        window.addEventListener('pointermove', this._moveHandler, false);
        window.addEventListener('pointerup', this._endHandler, false);
        window.addEventListener('pointercancel', this._endHandler, false);
    }
    _serializeTransformMatrix(m) {
        return `matrix3d(${m.a},${m.b},0,0,${m.c},${m.d},0,0,0,0,1,0,${m.e},${m.f},0,1)`;
    }
    _animateOffsetBy(delta, seconds, easing = Utils.Css.getVariableValue(`--${PCSS}-easing-out-sine`)) {
        const m = Matrix2D.translate(this.#originalTransform, delta);
        const time = Math.min(.3, seconds) * 1000;
        const element = this._element;
        const t = this._serializeTransformMatrix(m);
        return new Promise((resolve, _) => {
            const animation = element.animate([
                { transform: t }
            ], {
                fill: 'forwards',
                duration: time, easing
            });
            const callback = (e) => {
                animation.removeEventListener('finish', callback);
                animation.commitStyles();
                animation.cancel();
                resolve();
            };
            animation.addEventListener('finish', callback, false);
        });
    }
    _buildStateFromUiEvent(evt) {
        const coords = CustomEventUtils.getEventCoordinates(evt);
        const now = performance.now();
        const state = {
            position: coords.client,
            timestamp: now,
        };
        return state;
    }
    _buildSwipeArgsFromState(state = this.#state) {
        const options = this.#options;
        const speed = this.speed;
        const dir = this._swiper.direction;
        const vertical = dir === 'vertical';
        const horizontalspeed = vertical ? 0 : speed, verticalspeed = vertical ? speed : 0;
        // console.log("state:");
        // console.log(state.position);
        // console.log("init:");
        // console.log(this._init);
        // console.log(`vertical: ${vertical}`);
        // console.log(`h speed: ${horizontalspeed}`);
        // console.log(`v speed: ${verticalspeed}`);
        const args = SwipeEventArgsClass.fromArgs({
            position: state.position, element: this._element, t0: this._init, timestamp: state.timestamp, inertia: options.inertia, fling: options.fling,
            horizontalspeed, verticalspeed, vertical
        });
        //console.log(args);
        return args;
    }
    _delta(s0, s1) {
        const { position: { x: x0, y: y0 }, timestamp: t0 } = s0;
        const { position: { x: x1, y: y1 }, timestamp: t1 } = s1;
        const dir = this._swiper.direction;
        const delta = dir === 'vertical'
            ? { x: 0, y: y1 - y0 }
            : { x: x1 - x0, y: 0 };
        return { delta, time: t1 - t0 };
    }
    /** pixels/second */
    get speed() {
        const samples = this.#samples;
        if (samples.length < 2) {
            return 0;
        }
        const s0 = samples[0], s1 = samples[samples.length - 1];
        const { delta, time } = this._delta(s0, s1);
        const dt = time / 1000;
        const ds = delta.x + delta.y /* either x or y is 0, then this is a legit (and convenient) way to compute the magnitude */;
        return dt > 0 ? ds / dt : 0;
    }
    #options;
    #samples;
    #originalTransform;
    #state;
    dispose() {
        const el = this._element;
        DEL_VAL(el, DELEGATE_LABEL);
        window.removeEventListener('pointercancel', this._endHandler);
        window.removeEventListener('pointerup', this._endHandler);
    }
}
let PacemSwipeElement = class PacemSwipeElement extends PacemBehavior {
    constructor() {
        super(...arguments);
        this._prepareHandler = (evt) => {
            if (this.disabled) {
                return;
            }
            const coords = CustomEventUtils.getEventCoordinates(evt);
            const el = evt.currentTarget, origin = coords.client;
            // check the handle selector
            const hs = this.handleSelector;
            if (!Utils.isNullOrEmpty(hs)
                && el.querySelector(hs) !== evt.target) {
                return;
            }
            evt.stopPropagation();
            SET_VAL(el, PREPARING_LABEL, { position: origin, timestamp: performance.now() });
            SET_VAL(window, PREPARING_LABEL, el);
            window.addEventListener('pointermove', this._startHandler, false);
            window.addEventListener('pointerup', this._undoHandler, false);
        };
        this._startHandler = (evt) => {
            const el = GET_VAL(window, PREPARING_LABEL); // evt.currentTarget; // wrong! targets Window!
            const init = GET_VAL(el, PREPARING_LABEL);
            if (Utils.isNull(init)) {
                this._undo(el);
                return;
            }
            const coords = CustomEventUtils.getEventCoordinates(evt);
            const { x, y } = coords.client;
            const { position: { x: x0, y: y0 } } = init;
            const direction = this.direction || 'horizontal';
            const vertical = direction === 'vertical';
            const delta = vertical
                ? y - y0
                : x - x0;
            const options = this.#options, { start: threshold } = options;
            if (Math.abs(delta) > threshold) {
                // reset detection handlers
                // and remove attached data
                this._undo(el);
                // attach actual swipe delegate
                const swiper = this;
                const delegate = new SwipeElementDelegate(el, swiper, init, (level, message, category) => { swiper.log(level, message, category); });
                SET_VAL(el, DELEGATE_LABEL, delegate);
            }
        };
        this._undoHandler = (evt) => {
            const el = evt.currentTarget;
            this._undo(el);
        };
    }
    decorate(element) {
        // https://docs.microsoft.com/en-us/microsoft-edge/dev-guide/dom/pointer-events
        if (element instanceof HTMLElement || element instanceof SVGElement) {
            Utils.addClass(element, PCSS + '-swipe');
        }
        element.addEventListener('pointerdown', this._prepareHandler, false);
    }
    undecorate(element) {
        if (element instanceof HTMLElement || element instanceof SVGElement) {
            Utils.removeClass(element, PCSS + '-swipe');
        }
        element.removeEventListener('pointerdown', this._prepareHandler, false);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setOptions();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (first) {
            return;
        }
        switch (name) {
            case 'options':
                this._setOptions(val);
                break;
        }
    }
    #options;
    _setOptions(options = this.options) {
        this.#options = Utils.extend({}, DEFAULT_OPTIONS, options ?? {});
    }
    _undo(el) {
        window.removeEventListener('pointermove', this._startHandler);
        window.removeEventListener('pointerup', this._undoHandler);
        DEL_VAL(el, PREPARING_LABEL);
        DEL_VAL(window, PREPARING_LABEL);
    }
};
__decorate([
    Watch({
        emit: false, reflectBack: true, converter: {
            convert: (attr, _) => attr.match(/[-+]?[\d\.]+/g).map(i => parseFloat(i)),
            convertBack: (prop, _) => prop?.join(' ')
        }
    })
], PacemSwipeElement.prototype, "snaps", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String, reflectBack: true })
], PacemSwipeElement.prototype, "direction", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemSwipeElement.prototype, "options", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String, reflectBack: true })
], PacemSwipeElement.prototype, "handleSelector", void 0);
PacemSwipeElement = __decorate([
    CustomElement({ tagName: P + '-swipe' })
], PacemSwipeElement);
export { PacemSwipeElement };
//}
